import {Pipe, PipeTransform} from '@angular/core';
import moment from 'moment';

@Pipe({
    name: 'momentDate',
    standalone: false
})
export class MomentDatePipe implements PipeTransform {
  transform(value: string, format: string): string {

    // sollte laut Signatur nicht null sein, aber viele Tests explodieren ohne den Check
    if (value == null || value === '') return '';
    const replacedValue = value.replace('[Europe/Berlin]', '');
    if (replacedValue === '') return '';
    return moment(replacedValue).format(format);
  }
}
